import { GetMeQuery } from '../../graphql/api/queries/GetMe.generated'
import routes from '../../routes'
import { UserProfile } from '../../userprofile/types/preferences'
import { presettingLeafValues, presettingSoilValues } from '../../pages/Analyses/common/constants'
import { Country, Region, Unit } from '../../graphql/api/types'

export function extractUserProfile({ me }: GetMeQuery): UserProfile {
  if (!me) throw new Error('User data (me) is undefined in GetMeQuery response.')

  let redirectRoute = routes.INITIAL_ROUTE

  if (me.isBlocked || !me.isAuthorized) {
    redirectRoute = routes.pendingAuthorization
  } else if (!me.isOnboarded) {
    redirectRoute = routes.onboarding
  }

  return {
    userId: me.userId,
    name: me.name,
    email: me.email || '',
    phone: me.phone || '',
    group: me.group as UserProfile['group'],
    role: me.role,
    language: me.language || 'en',
    permissions: me.permissions,
    datePattern: me.datePattern || 'DD/MM/YYYY',
    density: me.density as Unit,
    weight: me.weight as Unit,
    length: me.length as Unit,
    area: me.area as Unit,
    volume: me.volume as Unit,
    areaDensity: me.areaDensity as Unit,
    country: me.country as Country,
    region: me.region as Region,
    isAdmin: me.isAdmin,
    isAuthorized: me.isAuthorized,
    isBlocked: me.isBlocked,
    isOnboarded: me.isOnboarded,
    shouldDisplaySidebarNav: me.isAuthorized && me.isOnboarded && !me.isBlocked,
    shouldDisplaySignupRoutes: me.isBlocked || !me.isOnboarded || !me.isAuthorized,
    redirectRoute: redirectRoute,
    soilAnalysisPresetting: presettingSoilValues,
    leafAnalysisPresetting: presettingLeafValues,
  }
}
